import moment from 'moment'

const ONBOARDING_SESSION_KEY = 'onboarding-session'
const ONBOARDING_SESSION_TIMEOUT_KEY = 'onboarding-session-timeout'

export function getOnboardingSession() {
  const timeout = localStorage.getItem(ONBOARDING_SESSION_TIMEOUT_KEY)
  if (!timeout) {
    return null
  }

  const startTime = moment(timeout)
  const endTime = moment()
  const differenceInMinutes = moment
    .duration(endTime.diff(startTime))
    .asMinutes()
  return differenceInMinutes >= 60
    ? null
    : localStorage.getItem(ONBOARDING_SESSION_KEY)
}

export function setOnboardingSession(sessionID) {
  localStorage.setItem(ONBOARDING_SESSION_KEY, sessionID)
  localStorage.setItem(ONBOARDING_SESSION_TIMEOUT_KEY, moment().toISOString())
}

export function clearOnboardingSession() {
  localStorage.removeItem(ONBOARDING_SESSION_KEY)
  localStorage.removeItem(ONBOARDING_SESSION_TIMEOUT_KEY)
}
